import { Fragment } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import { Link } from "react-router-dom";

const ShopPage = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}
        {pageText}

        <div className="home-request-page mb-5">
          <div id="externalBotton">
            <Link className="text-dark home-request-style" to="/shop">
              ثبت سفارش
            </Link>
          </div>
        </div>

        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default ShopPage;
